<template>
    <modal class="confirm" @close="close">
        <template #modal-header><slot name="modal-header"></slot></template>
        <template #modal-body>
            <div>
                <slot name="modal-body"></slot>
            </div>
        </template>
        <template #modal-footer>
            <div>
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="close"
                />
                <CompassButton :label="$t.__('common.actions.confirm')" @click="confirm" />
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from 'vcomponents/utilities/Modal.vue';

export default {
    components: {
        Modal,
    },
    props: {
        relatedtype: {
            type: String,
            required: true,
        },

        relatedid: {
            type: Number,
            required: true,
        },
    },
    methods: {
        close() {
            this.$emit('close');
        },

        confirm() {
            this.$emit('confirm', this.$props);
            this.$emit('close');
        },
    },
};
</script>
